import styled, { css } from 'styled-components';

export const ModalContent = styled.div(
  ({ theme }) => css`
    align-items: center;
    display: flex;
    flex-direction: column;
    padding: ${theme.sz.s4};
    text-align: center;

    @media (min-width: ${theme.sz.md}) {
      padding: ${theme.sz.s8} ${theme.sz.s10};
    }
  `,
);

export const ImageContainer = styled.div(
  ({ theme }) => css`
    height: calc(${theme.sz.s48} + ${theme.sz.s2});
    position: relative;
    width: ${theme.sz.s48};

    @media (min-width: ${theme.sz.md}) {
      height: calc(${theme.sz.xs} + ${theme.sz.s11});
      width: calc(${theme.sz.xs} + ${theme.sz.s5});
    }
  `,
);

export const Title = styled.h2(
  ({ theme }) => css`
    ${theme.typography.heading.mobile.xs};
    color: ${theme.co.secondary20};
    margin-top: ${theme.sz.s3};
    margin-bottom: ${theme.sz.s2};

    @media (min-width: ${theme.sz.md}) {
      ${theme.typography.heading.desktop.m};
      margin-bottom: ${theme.sz.s3};
      margin-top: ${theme.sz.s6};
    }
  `,
);

export const Description = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.sz.s5};
    padding-right: ${theme.sz.s2};
    margin-bottom: ${theme.sz.s3};

    @media (min-width: ${theme.sz.md}) {
      gap: ${theme.sz.s7};
      margin-bottom: ${theme.sz.s6};
    }
  `,
);

export const Paragraph = styled.p(
  ({ theme }) => css`
    ${theme.typography.paragraph.m};
    color: ${theme.co.secondary20};
    padding: 0;
    margin: 0;

    @media (min-width: ${theme.sz.md}) {
      ${theme.typography.paragraph.l};
    }
  `,
);

export const ActionButton = styled.div(
  () => css`
    width: 100%;
  `,
);

export const ProgressIndicator = styled.div(
  ({ theme }) => css`
    color: ${theme.co.secondary50};
    ${theme.typography.paragraph.m};
    margin-top: ${theme.sz.s3};

    @media (min-width: ${theme.sz.md}) {
      ${theme.typography.paragraph.base};
      margin-top: ${theme.sz.s6};
    }
  `,
);
